import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import CollectionHolder from '../organisms/CollectionHolder';
import { avatarData } from '../data/avatarData';

const Holder = styled.main`
  img {
    display: block;
    width: 100%;
    height: auto;
  }

  .button.small {
    margin-left: 1rem;
    margin-bottom: 1rem;

    &:first-of-type {
      margin-left: 0;
    }

    &.active {
      color: ${props => props.theme.colours.white};
      background-color: ${props => props.theme.colours.link};
    }
  }
`;

const ImageWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  overflow: hidden;
  height: 0;
  padding-bottom: 90%;
  border-radius: 50%;
  background-color: ${props => props.theme.colours.lightGrey2};
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;

class Gallery extends Component {

  render() {
    return (
      <Holder>
        <Link className="button small" to="/">Home</Link>
        {avatarData.map(avatar => (
          <Link className={`button small ${avatar.id === this.props.id && 'active'}`} to={`/${avatar.name}-gallery`}>Avatar {avatar.id}</Link>
        ))}
        <h1>Avatar {this.props.id} Gallery</h1>
        <ImageWrapper>
          <img src={this.props.image} alt="Avatar"/>
        </ImageWrapper>
        <CollectionHolder avatarPrefix={this.props.prefix}/>
      </Holder>
    )
  }
}

export default Gallery;
